module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_innlandet_pos.7b742c9c.pdf";